import { Container } from 'react-bootstrap'
import ReportFooter from '../ReportsFooter/ReportFooter'
import PieChart from '../IncidentAnalysis/Chart/PieChart'
import RotatingLinesLoader from '../../../../../../components/_shared/Loaders/RotatingLinesLoader'
import { columns } from './Table/urlVsIncidentColumn'
import ReactDataTable from '../../../../../../components/_shared/Table/ReactDataTable'

const UrlsVsIncidentTable = ({
    data,
    DisplayDate,
    isLoading,
    onPdfClick,
    onExcelClick,
    reportData,
    reportTableData,
    reportCode,
}) => {
    const labels = ['Incidents', 'Urls']
    const counts = [data?.incidentcount, data?.eventcount]

    // FIX: Make single row array
    const tableData = data ? [data] : [];

    return (
        <>
            <div className="mb-4">
                <h1>URLs VS Incidents</h1>
                <p className="fw-bold py-2">
                    Date:
                    <span className="ms-2 fw-normal text-muted">
                        {DisplayDate?.startDate} to {DisplayDate?.endDate}
                    </span>
                </p>
            </div>

            {isLoading ? (
                <RotatingLinesLoader />
            ) : (
                <>
                    <ReactDataTable
                        isLoading={isLoading}
                        data={tableData}  
                        columns={columns}
                        removePagination={true}
                    />

                    <Container fluid className="p-0 mt-4">
                        <div className="rounded-lg shadow-sm border newReport py-4" style={{ height: '400px' }}>
                            <PieChart labels={labels} counts={counts} />
                        </div>
                    </Container>
                </>
            )}

            <ReportFooter
                BackText={'Back'}
                PdfText={'PDF'}
                MailText={'Mail'}
                ExcelText={'Excel'}
                onPdfClick={onPdfClick}
                onExcelClick={onExcelClick}
                reportData={reportData}
                reportTableData={tableData}  
                generatePDFFunction={onPdfClick}
                reportCode={reportCode}
            />
        </>
    )
}

export default UrlsVsIncidentTable